import React, { FC } from "react";
import { ServiceCart } from "./ServiceCard";
import { SERVICE_CARDS } from "./constants";
import { FolderWrapper } from "../FolderWrapper";
import { SECTION_IDS } from "../constants";

export const ServicesSection: FC = () => (
  <FolderWrapper
    title="Послуги"
    titleClassName="text-green-base"
    className="grid grid-cols-2 content-center bg-white-base relative px-5 py-8.25 lg:grid-cols-3 lg:grid-rows-3 lg:px-25 lg:py-15 2xl:px-31 2xl:py-18"
    id={SECTION_IDS.SERVICES}
  >
    {SERVICE_CARDS.map((cart) => (
      <ServiceCart key={cart.id} {...cart} />
    ))}
  </FolderWrapper>
);
